import React__default from 'react';
import classnames from 'classnames';
import { Selectors } from '@grandvisionhq/auth';
import { Link } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';
import { useIntl, useSelector } from '@grandvisionhq/state';

const SectionHeading = ({ iconName , children  })=>/*#__PURE__*/ React__default.createElement("div", {
        className: "support__section-heading"
    }, /*#__PURE__*/ React__default.createElement(Icon, {
        name: iconName
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "subheading1"
    }, children))
;
const Support = ({ className  })=>{
    const { getLabel , getFormattedLabel  } = useIntl();
    const featuresLinks = useSelector(Selectors.getSupportFeaturesLinks);
    return /*#__PURE__*/ React__default.createElement("div", {
        className: classnames('support', className)
    }, /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest"
    }, getLabel('account.profile.support.title')), /*#__PURE__*/ React__default.createElement("div", {
        className: "support__sections"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "support__section"
    }, /*#__PURE__*/ React__default.createElement(SectionHeading, {
        iconName: "user"
    }, getLabel('account.profile.support.features.title')), /*#__PURE__*/ React__default.createElement("ul", {
        className: "support__features-links"
    }, featuresLinks && featuresLinks.map(({ url , label  }, i)=>url && /*#__PURE__*/ React__default.createElement("li", {
            key: i,
            className: "support__features-link"
        }, /*#__PURE__*/ React__default.createElement(Link, {
            iconAfter: "chevron-right",
            url: url
        }, getLabel(label)))
    ))), /*#__PURE__*/ React__default.createElement("div", {
        className: "support__section"
    }, /*#__PURE__*/ React__default.createElement(SectionHeading, {
        iconName: "info"
    }, getLabel('account.profile.support.contact.title')), /*#__PURE__*/ React__default.createElement(Text, null, getFormattedLabel('account.profile.support.contact.description', {
        parseHTML: true,
        parseLink: true
    })))));
};
var Support$1 = Support;

export { Support$1 as default };
//# sourceMappingURL=Support.js.map
